import GlobalMastersOld from './GlobalMastersOld';

export default GlobalMastersOld;
